export default __webpack_public_path__ + "static/media/arrow_bottom_down.f687dabe.svg";